export const replaceFileExtension = (
  filename: string,
  newExtension: string
): null | string => {
  // Ensure the new extension starts with a dot
  if (!newExtension.startsWith(".")) {
    newExtension = "." + newExtension;
  }

  // Find the last dot in the filename
  const lastDotIndex = filename.lastIndexOf(".");

  // If no dot is found or it's the first character, append the new extension
  if (lastDotIndex <= 0) {
    return filename + newExtension;
  }

  // Replace the existing extension
  return filename.substring(0, lastDotIndex) + newExtension;
};
